module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_3_5_4.9f2229ff.jpeg";